import { AbpMultiTenancyService } from 'abp-ng2-module';
import { Injectable } from '@angular/core';
import { ApplicationInfoDto, SessionServiceProxy, GetCurrentLoginInformationsOutput, PatientLoginInfoDto } from '../service-proxies/service-proxies';
import { catchError, map, tap } from 'rxjs/operators';
import { firstValueFrom, of } from 'rxjs';

@Injectable()
export class AppSessionService {

  private _user?: PatientLoginInfoDto;
  private _application?: ApplicationInfoDto;

  constructor(
    private _sessionService: SessionServiceProxy,
    private _abpMultiTenancyService: AbpMultiTenancyService) {
  }

  get application() {
    return this._application;
  }

  get patientUser() {
    return this._user;
  }

  get patientUserId() {
    return this.patientUser ? this.patientUser.id : null;
  }

  getShownLoginName(): string {
    if (!this._user) return '';
    return `${this._user.name} ${this._user.surname?.charAt(0)}`;
  }

  init(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      firstValueFrom(this._sessionService.getCurrentLoginInformations()).then((result: GetCurrentLoginInformationsOutput) => {
        this._application = result.application;
        this._user = result.patient;

        resolve(true);
      }, (err) => {
        reject(err);
      });
    });
  }

  refresh() {
    return this._sessionService.getCurrentLoginInformations().pipe(
      tap(result => {
        this._application = result.application;
        this._user = result.patient;
      }),
      map(result => result.patient),
      catchError(() => of(undefined).pipe(
        tap(() => {
          this._user = undefined;
        })
      ))
    );
  }
}
